const INSTALLATION_STEPS = {
  start: { label: "Start", color: "gray" },
  scan: { label: "Scan", color: "yellow" },
  dvr: { label: "DVR", color: "yellow" },
  router: { label: "Router", color: "purple" },
  port_forwarding: { label: "Port Forwarding", color: "purple" },
  ddns: { label: "DDNS", color: "purple" },
  preparation: { label: "Preparation", color: "orange" },
  logistics: { label: "Logistics", color: "orange" },
  delivered: { label: "Delivered", color: "orange" },
  rtsp_config: { label: "RTSP Configuration", color: "purple" },
  channel_selection: { label: "Channel Selection", color: "purple" },
  waiting_for_veesion: { label: "Waiting for Veesion", color: "blue" },
  user_creation: { label: "User Creation", color: "blue" },
  completed: { label: "Completed", color: "green" },
};

export const COMMUNICATION_LANGUAGES = [
  { value: "", label: "Default (English)" },
  { value: "en", label: "English (en)" },
  { value: "pt", label: "Portuguese (pt)" },
  { value: "fr", label: "French (fr)" },
  { value: "es", label: "Spanish (es)" },
  { value: "it", label: "Italian (it)" },
];

export default INSTALLATION_STEPS;
